// app/javascript/modules/tabs.js

var MAX_TABS = 15;
var STORAGE_KEY = 'admin-tabs';
var HOME_URL = '/admin';
var HOME_TITLE = '数据概览';

function getTabs() {
  try {
    var stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored) return JSON.parse(stored);
  } catch(e) {}
  return [{ url: HOME_URL, title: HOME_TITLE, closable: false }];
}

function saveTabs(tabs) {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(tabs));
}

function getCurrentTitle() {
  var bc = document.querySelector('.breadcrumb-current');
  if (bc && bc.textContent.trim()) return bc.textContent.trim();
  return document.title.replace(' | i旅游 Admin', '').trim() || '未命名';
}

function isHomeUrl(url) {
  return url === HOME_URL || url === HOME_URL + '/' || url.endsWith('/admin');
}

function renderTabs() {
  var tabBar = document.getElementById('tab-bar');
  if (!tabBar) return;

  var tabs = getTabs();
  var currentPath = window.location.pathname;

  tabBar.innerHTML = '';
  tabs.forEach(function(tab, index) {
    var tabPath = tab.url.split('?')[0];
    var item = document.createElement('div');
    item.className = 'tab-item' + (tabPath === currentPath ? ' active' : '');
    item.dataset.url = tab.url;

    var label = document.createElement('span');
    label.textContent = tab.title;
    item.appendChild(label);

    if (tab.closable) {
      var close = document.createElement('span');
      close.className = 'tab-item-close';
      close.innerHTML = '<svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>';
      close.addEventListener('click', function(e) {
        e.stopPropagation();
        closeTab(index);
      });
      item.appendChild(close);
    }

    item.addEventListener('click', function() {
      if (tabPath !== currentPath) {
        Turbolinks.visit(tab.url);
      }
    });

    tabBar.appendChild(item);
  });
}

function closeTab(index) {
  var tabs = getTabs();
  if (index < 0 || index >= tabs.length) return;
  if (!tabs[index].closable) return;

  var wasActive = tabs[index].url === (window.location.pathname + window.location.search);
  tabs.splice(index, 1);
  saveTabs(tabs);

  if (wasActive) {
    var newIndex = Math.min(index, tabs.length - 1);
    Turbolinks.visit(tabs[newIndex].url);
  } else {
    renderTabs();
  }
}

function addCurrentTab() {
  var currentPath = window.location.pathname;
  var currentUrl = window.location.pathname + window.location.search;
  var tabs = getTabs();

  // Match by pathname (ignore query params) to avoid creating new tabs on search
  var existing = tabs.find(function(t) { return t.url.split('?')[0] === currentPath; });
  if (existing) {
    existing.title = getCurrentTitle();
    existing.url = currentUrl; // Update URL to include latest search params
    saveTabs(tabs);
    return;
  }

  // Check max limit
  if (tabs.length >= MAX_TABS) {
    showToast('最多打开 ' + MAX_TABS + ' 个页签');
    Turbolinks.visit(HOME_URL);
    return;
  }

  tabs.push({
    url: currentUrl,
    title: getCurrentTitle(),
    closable: !isHomeUrl(currentPath)
  });
  saveTabs(tabs);
}

function showToast(message) {
  var toast = document.createElement('div');
  toast.className = 'tab-toast';
  toast.innerHTML = '<svg class="w-4 h-4 text-danger" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg><span>' + message + '</span>';
  document.body.appendChild(toast);

  requestAnimationFrame(function() {
    toast.classList.add('tab-toast-show');
  });

  setTimeout(function() {
    toast.classList.remove('tab-toast-show');
    setTimeout(function() { toast.remove(); }, 300);
  }, 2500);
}

function initTabs() {
  var tabBar = document.getElementById('tab-bar');
  if (!tabBar) return;
  addCurrentTab();
  renderTabs();
}

document.addEventListener('turbolinks:load', initTabs);
